import { render, staticRenderFns } from "./RapportsRestaurant.vue?vue&type=template&id=13b97079&scoped=true"
import script from "./RapportsRestaurant.vue?vue&type=script&lang=js"
export * from "./RapportsRestaurant.vue?vue&type=script&lang=js"
import style0 from "./RapportsRestaurant.vue?vue&type=style&index=0&id=13b97079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b97079",
  null
  
)

export default component.exports